import PropTypes from 'prop-types';

const addressPropType = {
  id: PropTypes.string,
  additionalStreetInfo: PropTypes.string,
  city: PropTypes.string,
  company: PropTypes.string,
  country: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  poBox: PropTypes.string,
  postalCode: PropTypes.string,
  region: PropTypes.string,
  state: PropTypes.string,
  streetName: PropTypes.string,
  streetNumber: PropTypes.string,
  phone: PropTypes.string,
  client_id: PropTypes.string,
  email: PropTypes.string,
  metadata: PropTypes.object,
  type: PropTypes.string,
  county: PropTypes.string,
};

// NOTE: THIS SHOULD BE EXPORTED FROM ADDRESS FORM.
export const ValidationStatus = {
  /** Address validated with high score. */
  VALID: 'VALID',
  /** Partial match with medium score. Confirm this with shopper. */
  QUESTIONABLE: 'QUESTIONABLE',
  /** Poor match with low score, or ambiguous, or reverted.  Encourage shopper to re-edit. */
  POOR: 'POOR',
  /** Unable to verify address at all. */
  UNVERIFIED: 'UNVERIFIED',
  /** Something went wrong calling the API. */
  API_ERROR: 'API_ERROR',
  /** No attempt was made to verify the address. */
  NOT_CONFIGURED: 'NOT_CONFIGURED',
};

export default addressPropType;
